// Load utils
import { debounce, updateLayoutVars, setCSSVar } from "./tools/utils";
import { gridDebug } from "./tools/gridDebug";

// Load components
import { BurgerMenu } from "./components/BurgerMenu";
import { Slider } from "./components/Sliders";
import { FloatLabel } from "./components/FloatLabel";

const isDesktop = () => window.matchMedia("(min-width: 1061px)").matches;

/**
 * WPBakery (Waypoints) n’ajoute pas toujours `wpb_start_animation` aux blocs
 * déjà dans le viewport au premier paint — ils restent alors invisibles (opacity: 0).
 */
function revealWpbAnimationsIfInView() {
	const vh = window.innerHeight || document.documentElement.clientHeight;
	document.querySelectorAll(".wpb_animate_when_almost_visible:not(.wpb_start_animation)").forEach((el) => {
		const rect = el.getBoundingClientRect();
		if (rect.bottom > 0 && rect.top < vh) {
			el.classList.add("wpb_start_animation");
		}
	});
}

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	if (themeVars.is_dev) gridDebug.init();

	revealWpbAnimationsIfInView();
	requestAnimationFrame(revealWpbAnimationsIfInView);
	window.addEventListener("load", revealWpbAnimationsIfInView, { once: true });

	// update layout vars
	updateLayoutVars();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	// Init components
	BurgerMenu.init();
	FloatLabel.init();

	// Make slider from reviews
	const sliders_services = document.querySelectorAll(".services-slider");

	if (sliders_services) {
		sliders_services.forEach((slider) => {
			const slider_ctn = slider.querySelector(".swiper");
			Slider.initSwiper(slider_ctn, {
				navigation: {
					prevEl: slider.querySelector(".js-services-prev"),
					nextEl: slider.querySelector(".js-services-next"),
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 16,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 32,
					},
				},
			});
		});
	}

	// Observe header
	const header = document.querySelector(".header");
	const header_ban = document.querySelector(".header-ban-info");
	const container = document.querySelector(".site-container");

	if (header) {
		setCSSVar("--_header-h", `${header.offsetHeight}px`, "body");
		if (header_ban) {
			setCSSVar("--_header-ban-h", `${header_ban.offsetHeight}px`, "body");
		}

		window.addEventListener("scroll", () => document.body.classList.toggle("header-is-sticky", window.scrollY > header.offsetHeight));

		window.addEventListener("scroll", () => {
			const containerRect = container.getBoundingClientRect();
			const headerHeight = header.offsetHeight;

			// si le header dépasse le bas du container
			if (containerRect.bottom + 50 <= headerHeight) {
				header.classList.add("is-hidden");
			} else {
				header.classList.remove("is-hidden");
			}
		});
	}

	// Subnav stuffs
	const nav = document.querySelector(".main-nav");
	if (nav) {
		const toggleBodyClass = (add) => {
			document.body.classList.toggle("has-subnav-open", add);
		};

		// Desktop nav
		nav.addEventListener("mouseover", (e) => {
			if (!isDesktop()) return;

			const menuItem = e.target.closest(".main-nav__item.menu-item-has-children");
			if (!menuItem || !nav.contains(menuItem)) return;

			toggleBodyClass(true);
		});

		nav.addEventListener("mouseout", (e) => {
			if (!isDesktop()) return;

			const menuItem = e.target.closest(".main-nav__item.menu-item-has-children");
			if (!menuItem || !nav.contains(menuItem)) return;

			if (menuItem.matches(":hover")) return;

			toggleBodyClass(false);
		});

		// Mobilde nav
		nav.addEventListener("click", (e) => {
			if (isDesktop()) return;

			const trigger = e.target.closest(".main-nav__trigger-drop");
			if (!trigger) return;

			const menuItem = trigger.closest(".main-nav__item.menu-item-has-children");
			if (!menuItem) return;

			e.preventDefault();

			const isOpen = menuItem.classList.contains("is-open");

			// Ferme les autres sous-menus
			nav.querySelectorAll(".main-nav__item.is-open").forEach((item) => {
				item.classList.remove("is-open");
			});

			// Toggle le courant
			menuItem.classList.toggle("is-open", !isOpen);

			// Body class si au moins un subnav ouvert
			toggleBodyClass(!isOpen);
		});
	}

	// Language trigger
	const lang_trigger = document.querySelector(".js-open-lang");
	if (lang_trigger) {
		lang_trigger.addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector(".lang-switcher").classList.toggle("is-open");
		});
	}

	new PerformanceObserver((list) => {
		const latestEntry = list.getEntries().at(-1);

		if (latestEntry?.element?.getAttribute("loading") == "lazy") {
			console.warn("Warning: LCP element was lazy loaded", latestEntry);
		}
	}).observe({ type: "largest-contentful-paint", buffered: true });
});
